import api from '../api/axios';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export interface MergeInputVideoPayload {
  url: string;
  type: 'image' | 'video';
  index: number;
  durationMs?: number;
  transitionType?: string;
  transitionDurationMs?: number;
   orderNo?: number | null;
   runId?: string | null;
}

export interface MergeGlobalSettingsPayload {
  fps: number;
  container: string;
  audioCodec: string;
  videoCodec: string;
  transitionType: string;
  resolutionWidth: number;
  resolutionHeight: number;
  transitionDurationMs: number;
}

export interface CreateVideoMergeJobPayload {
  inputVideos: MergeInputVideoPayload[];
  globalSettings: MergeGlobalSettingsPayload;
  title?: string | null;
}

export const createMergeJob = async (payload: CreateVideoMergeJobPayload) => {
  const res = await api.post(withBase('/video-merge-jobs'), payload);
  return res.data as { isNew: boolean; job: any };
};

export const getAllMergeJobs = async () => {
  const res = await api.get(withBase('/video-merge-jobs'));
  return res.data as any[];
};

export const deleteMergeJob = async (id: string) => {
  const res = await api.delete(withBase(`/video-merge-jobs/${id}`));
  return res.data as { deleted: boolean };
};

const videoMergeJobsService = {
  createMergeJob,
  getAllMergeJobs,
  deleteMergeJob,
};

export default videoMergeJobsService;
